import { Link } from "react-router-dom";

export default function CtaSection() {
  return (
    <section className="relative py-20 md:py-28 px-4 md:px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20textured%20background%20with%20warm%20earthy%20tones%20terracotta%20and%20amber%2C%20organic%20flowing%20shapes%2C%20subtle%20golden%20light%20streaks%2C%20painterly%20artistic%20style%2C%20sophisticated%20minimal%20composition%2C%20no%20people&width=1800&height=600&seq=cta-home-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-foreground-950/75"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-5">
          开始探索千万正版素材库
        </h2>
        <p className="text-background-50/70 text-base md:text-lg mb-10 leading-relaxed">
          加入超过200万企业客户的选择，获取海量原创内容资源，
          让创作者资源中心为您的创作与品牌传播效率赋能。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/image-text"
            className="px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full text-base font-semibold transition-all duration-200 whitespace-nowrap"
            onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
          >
            立即探索资源库
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 border border-background-50/30 hover:bg-background-50/10 text-background-50 rounded-full text-base font-semibold transition-all duration-200 whitespace-nowrap"
            onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}